import { Lookup } from '../lookup.interface';

export const ConsentTypes: { [name: string]: Lookup } = {
  thirdParty: { code: 'thirdParty', displayValue: 'Third party' },
  thrivePlatform: { code: 'thrivePlatform', displayValue: 'Thrive platform' },
  informationSharing: { code: 'informationSharing', displayValue: 'Information sharing' },
};
